export const DRIVER = {
  firstName: "Lucas",
  lastName: "Pasquinetti",
  number: "77",
  team: "Trident",
  championship: "Campionato Italiano F4",
  championshipShort: "Italian F4",
  nationality: "Italia",
  instagram: "lucaspasquinetti77",
  email: "info.lucaspasquinetti77@gmail.com",
  car: "Tatuus F4 T-421",
  season: "2026",
};

export const INSTAGRAM_URL = `https://instagram.com/${DRIVER.instagram}`;

export const SPECS = [
  { key: "number", v: "#77" },
  { key: "team", v: DRIVER.team },
  { key: "championship", v: DRIVER.championshipShort },
  { key: "nationality", v: { it: "Italia", en: "Italy" } },
  { key: "car", v: DRIVER.car },
  { key: "instagram", v: `@${DRIVER.instagram}` },
];

export const NAV_LINKS = ["bio", "calendario", "news", "galleria", "sponsor"];

export const MARQUEE_LOGOS = [
  { src: "/brand/m-trident.png", alt: "Trident", cls: "h-14 md:h-20" },
  { src: "/brand/m-cetilar.png", alt: "Athletica Cetilar", cls: "h-12 md:h-16" },
  { src: "/brand/m-jamor.png", alt: "Jamór", cls: "h-14 md:h-20" },
  { src: "/brand/m-biomar.png", alt: "Biomar", cls: "h-8 md:h-11" },
  { src: "/brand/m-edvance.png", alt: "Edvance", cls: "h-7 md:h-9" },
];

export const MARQUEE_WORDS = ["Lucas Pasquinetti", "#77", "Trident", "Italian F4", "Lights out", "Full send", "Forza 77"];
